<template>
  <div class="main">
    <div class="form-row">
      <div class="form-field">
        <label for="user-select">Выберите контроллер:</label>
        <select id="user-select" v-model="idCtrl">
          <option
            v-for="(ctrl, key) in controllers"
            :value="ctrl.ID"
            :key="key"
            >{{ ctrl.NAME }}</option
          >
        </select>
      </div>
      <div class="form-field">
        <img v-show="waite" src="@/assets/wait.gif" class="waite" />
      </div>
      <div class="form-field" v-show="idCtrl && !waite">
        <button @click="openDoor">Открыть</button>
      </div>
    </div>
    <div class="form-row" v-if="info">{{ info }}</div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "PassAdd",
  data() {
    return {
      url: config.backend_url,
      controllers: {},
      idCtrl: false,
      info: false,
      waite: false
    };
  },
  methods: {
    openDoor: function() {
      let self = this;
      self.waite = true;
      let data = {
        url: self.url + "parsec/open-door/",
        data: { idCtrl: self.idCtrl },
        method: "POST"
      };
      this.$store.dispatch("query/sendRequest", data).then(function(response) {
        let data = response.data;
        console.log(data);
        self.waite = false;
      });
    }
  },
  mounted() {
    let self = this;
    self.waite = true;
    let data = {
      url: self.url + "parsec/get-territories/",
      data: {},
      method: "POST"
    };
    this.$store.dispatch("query/sendRequest", data).then(function(response) {
      let data = response.data;
      if (data) {
        self.controllers = data;
      } else {
        self.info = "Ошибка получения списка контроллеров";
      }
      self.waite = false;
    });
  }
};
</script>
